<div class="form-group">
  <div
    *ngFor="
      let dataValue of dataValues;
      let i = &quot;index+1&quot;;
      first as isFirst;
      last as isLast
    "
    [class.first-child]="isFirst"
    [class.last-child]="isLast"
  >
    <input
      [formControl]="formControl"
      type="radio"
      [value]="dataValue.value"
      id="{{ 'Radio' + i }}"
    />
    <label for="{{ 'Radio' + i }}">{{ dataValue.label }}</label>
  </div>
</div>
